import styled from 'styled-components';

// @ts-expect-error not converted to TS
import ReferenceInputEnumSearch from 'customer-data-reference-ui-components/enum/ReferenceInputEnumSearch';
import FormattedMessageWithObjectTypeName from 'automation-ui-i18n/FormattedMessageWithObjectTypeName';
import WiredCustomObjectResolver from 'automation-ui-enrollment/components/common/WiredCustomObjectResolver';
import { isCustomObject } from 'automation-ui-references/object-types/objectTypeUtils';
import CustomObjectFilterSelect from 'automation-ui-log-events/components/CustomObjectFilterSelect';
import filterObjectOptions from 'automation-ui-log-events/utils/filterObjectOptions';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFilterBar = styled(ReferenceInputEnumSearch).withConfig({
  displayName: "ObjectFilterSelect__StyledFilterBar",
  componentId: "drq6gj-0"
})(["&&{", " width:100% !important;}"], ({
  menuWidth
}) => `max-width: ${menuWidth || 400}px;}`);
const ObjectFilterSelect = ({
  flowObjectTypeId,
  updateUrlFilters,
  selectedObjectId,
  disabled,
  menuWidth,
  'data-test-id': dataTestId,
  resolver,
  isMultiSelectEnabled,
  itemComponent,
  filterObjectOptionsOverride = filterObjectOptions,
  extraSelectProps
}) => {
  if (isCustomObject(flowObjectTypeId) && !isMultiSelectEnabled) {
    return /*#__PURE__*/_jsx(CustomObjectFilterSelect, {
      flowObjectTypeId: flowObjectTypeId,
      menuWidth: menuWidth,
      onChange: updateUrlFilters,
      selectedObjectId: selectedObjectId,
      "data-test-id": dataTestId
    });
  }
  if (!resolver) {
    return null;
  }
  let value = null;
  if (selectedObjectId) {
    if (typeof selectedObjectId === 'number') {
      value = String(selectedObjectId);
    } else {
      value = selectedObjectId.map(id => String(id));
    }
  }
  return /*#__PURE__*/_jsx(StyledFilterBar, Object.assign({
    disabled: disabled,
    onChange: updateUrlFilters,
    placeholder: /*#__PURE__*/_jsx(FormattedMessageWithObjectTypeName, {
      baseLangKey: "automation-ui-log-events.filters.objectFilterSelect.placeholder_cob",
      objectTypeId: flowObjectTypeId
    }),
    resolver: resolver,
    searchCount: 50,
    searchDebounceTimeout: 300,
    value: value,
    clearable: true,
    menuWidth: menuWidth,
    "data-test-id": dataTestId,
    filterOptions: filterObjectOptionsOverride,
    multi: isMultiSelectEnabled,
    itemComponent: itemComponent
  }, extraSelectProps));
};
export default WiredCustomObjectResolver(ObjectFilterSelect);